<template>
    <div>
        <admin-modal
            :modal-id="modalId"
            modal-title="Waiting List Invite"
        >
            <template #form>
                <p><strong>Ref:</strong> {{ participant['Participants.id'] }}</p>
                <p><strong>Participant:</strong> {{ participant['Participants.first_name'] }}
                    {{ participant['Participants.last_name'] }}</p>
                <hr class="light">
                <admin-form
                    :submit-url="`/api/v0/participants/waiting_list_expired_actions/${participant.id}`"
                    :submit-method="'post'"
                    :entity='{}'
                    :ajax-only="true"
                    @success="handleSuccess"
                    @error="handleError"
                    @validation-error="handleValidationError"
                    :fields="[
                        {
                            'name': 'waiting_list_expire_action',
                            'label': 'What action would you like to take?',
                            'type': 'radio',
                            'options': filteredWaitingListExpiredActionOptions,
                            'defaultValue': '',
                            required: true
                        },
                    ]"
                ></admin-form>
            </template>
        </admin-modal>
        <notification-container :notifications="notifications"/>
    </div>
</template>

<script>
import NotificationContainer from '../Common/NotificationContainer.vue'
import notificationsMixin from '../../mixins/notifications.js'

export default {
    mixins: [notificationsMixin],
    components: {
        NotificationContainer
    },
    props: {
        participant: {
            type: Object,
            required: true
        },
        modalId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            waitingListExpiredActionOptions: [
                {"label": "Send invite again", "value": "invite_again"},
                {
                    "label": "Rejoin them and preserve their original waiting list joined date",
                    "value": "rejoin_preserved_waiting_list_joined_date"
                },
                {
                    "label": "Rejoin them and move them to the back of the queue",
                    "value": "rejoin_with_new_waiting_list_joined_date"
                },
            ]
        }
    },
    computed: {
        filteredWaitingListExpiredActionOptions() {
            if (this.participant['Participants.participant_status'] === 'waiting_list_invited') {
                return this.waitingListExpiredActionOptions.filter(option =>
                    option.value !== 'rejoin_preserved_waiting_list_joined_date' &&
                    option.value !== 'rejoin_with_new_waiting_list_joined_date'
                );
            }

            return this.waitingListExpiredActionOptions;
        }
    },
    methods: {
        handleSuccess(data) {
            $(`#${this.modalId}`).modal('hide');
            // Delay notification to ensure modal has fully closed
            this.showAlertMessage('Action completed successfully!', 'success', 3000);
            this.$emit('success', data);
        },
        handleError(error) {
            this.showAlertMessage('Something went wrong. Please try again.', 'error', 5000);
        },
        handleValidationError(errors) {
            this.showAlertMessage('Please check your input and try again.', 'warning', 5000);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/WaitingListActionModal.vue